module.exports = __webpack_public_path__ + "fonts/Montserrat-Medium.c86e3b9.ttf";